import { render, staticRenderFns } from "./PxAutocompleteProjetoMultiple.vue?vue&type=template&id=d61937e8&"
import script from "./PxAutocompleteProjetoMultiple.vue?vue&type=script&lang=js&"
export * from "./PxAutocompleteProjetoMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VChip,VListItemContent,VListItemTitle})
